
import axios from 'axios';
import rutasrep from '@/assets/utils/rutas.json';


export const fetchArchivosPdf = async (
  especialidad = '',
  fechaDesde = '',
  fechaHasta = '',
  desde = 0,
  hasta = 15,
) =>{
  const query = `
    query qrallPlano(
      $doctorId: ID, $pacienteid: ID, $tipocobertura: String!
      $tiposeguro: String!, $especialidad: String!, $tipoarchivo: String!,
      $fechaDesde: String!, $fechaHasta: String!
          
    ){
      allPlanos(
        doctorid: $doctorId, pacienteid: $pacienteid,
        tipocobertura: $tipocobertura, tiposeguro: $tiposeguro,
        especialidad: $especialidad, tipoarchivo: $tipoarchivo,
        fechadesde: $fechaDesde, fechahasta: $fechaHasta, 
      ){
        total
        message
        status
        aplano{
          id
          usuarioCreador{
            username
          }
          doctor{
            idPersona{
              primerNombre
              primerApellido
            }
          }
          paciente{
            persona{
              primerNombre
              primerApellido
            }
          }
          fechaproceso
          finicio
          ffin
          tipocobertura{
            descripcion
          }
          especialidad {
            descripcion
          }
          tipoarchivo
          estadoarchivo
        }
      }
    }
  `;
  try {
    const var_consulta = {
      doctorId: '',
      pacienteid: '',
      tipocobertura: '',
      tiposeguro: '',
      especialidad: '',
      tipoarchivo: '',
      fechaDesde: '',
      fechaHasta: '',
    }
    const response = await axios.post(rutasrep.axiosrep + "api", {
      query,
      variables: var_consulta,
    });

    if (response.status === 200) {
      if (response.data.data.allPlanos.status === "success") {
        if (response.data.data.allPlanos.aplano) {
          this.itemsAP = response.data.data.allPlanos.aplano.map((item) => {
            return {
              id           : item.id,
              paciente     : item.paciente ? item.paciente.persona.primerApellido + ' ' + item.paciente.persona.primerNombre : 'Pacientes activos',
              doctor       : item.doctor ? `${item.doctor.idPersona.primerNombre} ${item.doctor.idPersona.primerApellido}` : '',
              fechaproceso : item.fechaproceso,
              fechainicio  : item.finicio,
              fechafin     : item.ffin,
              especialidad : item.especialidad.descripcion,
              tipocobertura: item.tipocobertura ? item.tipocobertura.descripcion : '',
              tipoarchivo  : this.opsSoloLIP.find(op => String(op.value) === item.tipoarchivo).text,
              usuario      : item.usuarioCreador ? item.usuarioCreador.username : '',
            };
          });
          this.totalRows = response.data.data.allPlanos.total;
          this.currentPage = 1;
          this.currentPageModificado = pagina_actual;
        } else {
          this.itemsAP = [];
          this.totalRows = 0;
          this.currentPage = 1;
          this.currentPageModificado = pagina_actual;
        }
      }
    }
  } catch (error) {
    console.error('An error occurred while fetching the options:', error);
  }
}



export const obtenerDataTablePdf = async () => {

 
  const query = `
      query MyQuery {
      allPdfs {
        message
        status
        total
        apdf {
           usuarioCreador {
            username
          }
          id
          especialidad
          establecimiento
          {
          id
          Descripcion}
          estado
          rutaArchivo
          descargar
          userDescargando
          estadoarchivo
          fechaCreacion
          ultimoCambio
          fechaproceso
          finicio
          ffin
          segurosalud
          tipocobertura
          tiposervicio
          doctor {
            id
            idPersona {
            primerNombre
            primerApellido
            identificacion
            }
          }
          paciente {
            id
            persona {
            primerNombre
            primerApellido
            identificacion
            }
          }
        }
      }
    }
  `;
  
  try {
    const response = await axios.post(rutasrep.axiosrep + "api", { query});
    console.log(response);
    let response_pdfs = [...response.data.data.allPdfs.apdf]
    response_pdfs.forEach(element => {
      let fecha = element.fechaCreacion.split('T')[0];
      let hora = element.fechaCreacion.split('T')[1].substring(0, 8);
      element.fechaproceso = fecha + ' ' + hora
      if(element.descargar === '3' || element.descargar === 3){
          let ult_fecha = element.ultimoCambio.split('T')[0];
          let ult_hora = element.ultimoCambio.split('T')[1].substring(0, 8);
          element.estadoDescarga = `Finalizado: ${ult_fecha} ${ult_hora}`
      }
    })
    return response_pdfs

  } catch (error) {
    console.log("Error al obtener la data table");
    return error;
  }

}

export const generarPdf = async ( variables ) => {

  if( !variables ){
    console.error('no envio varConsulta')
    return null;
  }

  const query = `
    mutation generarArchivoPdf(
      $idPaciente      : String
      $idDoctor        : String
      $establecimiento : ID
      $fechaDesde      : String
      $fechaHasta      : String
      $pacdoc          : String
      $fechaProceso    : String
      $tipoSeguro      : String!
      $tipoCobertura   : String!
      $especialidad    : String!
      $tipoServicio    : String!
  ) {
    crearArchivoPdf(
      idpaciente      : $idPaciente
      iddoctor        : $idDoctor
      establecimiento : $establecimiento
      finicio         : $fechaDesde
      ffin            : $fechaHasta
      pacdoc          : $pacdoc
      fechaproceso    : $fechaProceso
      tiposeguro      : $tipoSeguro
      tipocobertura   : $tipoCobertura
      especialidad    : $especialidad
      tiposervicio    : $tipoServicio
    ) {
        archivopdf {
          id
        }
        status
        message
      }
    }
  `;
  
  try {
    const response = await axios.post(rutasrep.axiosrep + "api", { query, variables });
    return response;

  } catch (error) {
    console.log("Error al generar el archivo plano");
    return error;
  }

}




export const infoPdfsAGenerar = async ( variables ) => {

  if( !variables ){
    console.error('no envio varConsulta')
    return null;
  }

  const query = `
    query obtenerCantArchpdf(
      $idPaciente      : String
      $idDoctor        : String
      $establecimiento : ID
      $fechaDesde      : String
      $fechaHasta      : String
      $pacdoc          : String
      $fechaProceso    : String
      $tipoSeguro      : String
      $tipoCobertura   : String
      $especialidad    : String
      $tipoServicio    : String
  ) {
    obtenerCantArchpdf(
      idpaciente      : $idPaciente
      iddoctor        : $idDoctor
      establecimiento : $establecimiento
      finicio         : $fechaDesde
      ffin            : $fechaHasta
      pacdoc          : $pacdoc
      fechaproceso    : $fechaProceso
      tiposeguro      : $tipoSeguro
      tipocobertura   : $tipoCobertura
      especialidad    : $especialidad
      tiposervicio    : $tipoServicio
    ) {
        imgdup
        labsdup
        mspscitas
        mspsimagenes
        mspslaboratorio
        rprincipal
        sinas400
        sincedula
        sindiag
        sinfirma
      }
    }
  `;
  
  try {
    const response = await axios.post(rutasrep.axiosrep + "api", { query, variables });

    const data = response.data.data.obtenerCantArchpdf;

    const { imgdup, labsdup, mspscitas, mspsimagenes, mspslaboratorio, rprincipal, sinas400, sincedula, sindiag, sinfirma } = data;

    const info = `
      <br>
      <div style = "text-align:justify">
      <p > <b> Imagenes duplicadas sin justificación: </b> ${imgdup}</p>
      <p > <b> Lab. duplicados sin justificación: </b> ${labsdup}</p>
      <p > <b> Citas sin cobertura: </b> ${mspscitas}</p>
      <p > <b> Laboratorios sin cobertura: </b> ${mspslaboratorio}</p>
      <p > <b> Imagenes sin cobertura: </b> ${mspsimagenes}</p>
      <p > <b> Diagnosticos R principal: </b> ${rprincipal}</p>
      <p > <b> Atenciones sin capturas as400: </b> ${sinas400}</p>
      <p > <b> Pacientes sin cedula: </b> ${sincedula}</p>
      <p > <b> Atenciones sin diagnosticos: </b> ${sindiag}</p>
      <p > <b> Atenciones sin firma: </b> ${sinfirma}</p>
      </div>
    `;
    
    return info;

  } catch (error) {
    console.log("Error al obtener la info");
    return error;
  }

}




export const infoPacientesPdfsAGenerar = async ( idArchivoPdf ) => {

  if( !idArchivoPdf ){
    console.error('no envio varConsulta')
    return null;
  }

  const query = `
    query MyQuery{
      obtenerInfoPacientespdf(idArchivoPdf: ${idArchivoPdf})
    }
  `;
  
  try {
    const response = await axios.post(rutasrep.axiosrep + "api", { query});
    
    return response.data.data.obtenerInfoPacientespdf;

  } catch (error) {
    console.log("Error al obtener la info");
    return error;
  }

}




